import { render, staticRenderFns } from "./integrationListItem.vue?vue&type=template&id=6f2b50d6&scoped=true&"
import script from "./integrationListItem.vue?vue&type=script&lang=js&"
export * from "./integrationListItem.vue?vue&type=script&lang=js&"
import style0 from "./integrationListItem.scss?vue&type=style&index=0&id=6f2b50d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b50d6",
  null
  
)

export default component.exports